import React from "react";
import PropTypes from "prop-types";

import { Table } from "antd";

const HistoryDataTable = ({
  data,
  columns,
  title,
  footer = null,
  pagination = false,
  onChange = () => {},
  loading = false,
  scroll,
  rowKey = null,
  expandable = {},
  titleTextAlign = "center",
}) => {
  console.log("data", data);
  return (
    <Table
      title={() => (
        <div
          style={{
            fontWeight: "bold",
            textAlign: titleTextAlign,
            textTransform: "uppercase",
          }}
        >
          {title}
        </div>
      )}
      scroll={scroll || { x: false, y: 300 }}
      dataSource={data}
      columns={columns}
      bordered
      rowKey={(record) =>
        record.id ?? (rowKey ? record[rowKey] : record.key ?? record.index)
      }
      pagination={pagination}
      footer={(currentPagedata) => footer?.(currentPagedata)}
      onChange={onChange}
      loading={loading}
      expandable={expandable}
    />
  );
};

HistoryDataTable.propTypes = {
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  title: PropTypes.element,
  footer: PropTypes.node,
  pagination: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  onChange: PropTypes.func,
  loading: PropTypes.bool,
  scroll: PropTypes.object,
  rowKey: PropTypes.string,
  expandable: PropTypes.object,
  titleTextAlign: PropTypes.string,
};

HistoryDataTable.defaultProps = {
  data: [],
  columns: [],
  rowKey: null,
};
export default HistoryDataTable;
